import {
  Switch as MISwitch,
  SwitchProps,
  FormControlLabel,
  FormControlLabelClassKey,
  StandardProps,
} from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

import classnames from "classnames";
import React from "react";

const StyledSwitch = withStyles({
  root: {
    "&$checked": {
      "& .MuiSwitch-track": {
        backgroundColor: "#308cdb94",
      },
    },
    "& .Mui-checked": {
      "& span": {
        color: "#308CDB",
      },
    },
    "& .MuiSwitch-track": {
      "&$checked": {
        backgroundColor: "#308cdb94",
      },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#308CDB",
    },
  },
  checked: {},
})((props: SwitchProps) => <MISwitch color="default" {...props} />);

const useStyles = makeStyles(() => ({
  label: {
    fontFamily: "'Manrope'",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "24px",
    color: "#465869",
  },
  controlLabel: {
    margin: 0,
  },
}));

interface Control extends SwitchProps {
  "data-cy"?: string;
}

interface Props
  extends StandardProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    FormControlLabelClassKey,
    "children" | "onChange"
  > {
  control?: Control;
  classNameLabel?: string;
  checked?: boolean;
  disabled?: boolean;
  label: React.ReactNode;
  labelPlacement?: "end" | "start" | "top" | "bottom";
  name?: string;
  onChange?: (event: React.ChangeEvent<{}>, checked: boolean) => void;
  value?: unknown;
}

const Switch = (props: Props) => {
  const classes = useStyles();

  return (
    <FormControlLabel
      {...props}
      className={
        props?.className ? classnames(classes.controlLabel, props?.className) : classes.controlLabel
      }
      label={<span className={`${classes.label} ${props.classNameLabel}`}>{props.label}</span>}
      control={<StyledSwitch {...props?.control} />}
    />
  );
};

export default Switch;
